/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Sch_Wf_Statuses_OfInputs */

const en_sch_wf_statuses_of = /** @type {(inputs: Sch_Wf_Statuses_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Statuses of ${i?.name}`)
};

const de_sch_wf_statuses_of = /** @type {(inputs: Sch_Wf_Statuses_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Status von ${i?.name}`)
};

/**
* | output |
* | --- |
* | "Statuses of {name}" |
*
* @param {Sch_Wf_Statuses_OfInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sch_wf_statuses_of = /** @type {((inputs: Sch_Wf_Statuses_OfInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sch_Wf_Statuses_OfInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_sch_wf_statuses_of(inputs)
	return en_sch_wf_statuses_of(inputs)
});